import {useCallback, useEffect, useState} from 'react'
import { getCustomSurvey } from './list/core/_requests'
import { Model as SurveyModel } from './list/core/_models'
import {createCustomSurveyApplication} from '../surveyapplication/list/core/_requests'
import {Model as SurveyApplicationModel} from '../surveyapplication/list/core/_models'
import 'survey-core/defaultV2.min.css'
import {StylesManager, Model} from 'survey-core'
import {Survey} from 'survey-react-ui'
import {useParams} from 'react-router-dom'
import 'survey-core/survey.i18n'

StylesManager.applyTheme('defaultV2')

const Preview = () => {
  const params = useParams()
    const [survey, setSurvey] = useState('')
    const [isloading, setisloading] = useState(true)
    const [surveyid, setsurveyid] = useState(0)
    
  useEffect(() => {
    getCustomSurvey(params.Guid).then((res) => {
      if (res != undefined) {
          const dt = res.data != undefined ? res.data.surveyJson : '0'
          const idt = res.data != undefined ? res.data.id : 0
          const jsp = JSON.parse(dt)
          console.log(idt)
          setSurvey(jsp)
          setsurveyid(parseInt(idt?.toString() || '0'))
        setisloading(false)
      }
    })
  }, [params])

    const alertResults = useCallback((sender: any) => {
        console.log(surveyid);
        if (surveyid != undefined && surveyid != 0) {
              const results = JSON.stringify(sender.data)
              const samodel = { id: 0, name: results, surveyId: surveyid }
            createCustomSurveyApplication(samodel)
        }
  }, [surveyid])

let md = new Model(survey)
      md.focusFirstQuestionAutomatic = false
      md.locale = 'tr'
    md.onComplete.add(alertResults)

  return !isloading ? (
    <div style={{backgroundColor: '#f3f3f3', height: '100vh'}}>
      <Survey model={md} />{' '}
    </div>
  ) : (
    <div></div>
  )
}

export {Preview}
